import LeagueCategoryIndex from './LeagueCategoryIndex';
import LeagueCategoryCreate from './LeagueCategoryCreate';
import LeagueCategorySettings from './LeagueCategorySettings';
import LeagueCategorySingle from './LeagueCategorySingle';

export default function (app) {

    const settings = LeagueCategorySettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 9,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    LeagueCategoryIndex(app, settings);

    LeagueCategoryCreate(app, settings);

    LeagueCategorySingle(app, settings);

}